import { useMemo } from 'react';

import { gradeSelectById } from '@/Module/Grade/Store/Selector';
import { useAppSelector } from '@/Module/Store/Hook';

export const useGrade = () => {
  const gradeElementary = useAppSelector(state => gradeSelectById(state, 31))!;
  const gradeFirst = useAppSelector(state => gradeSelectById(state, 32))!;
  const gradeSecond = useAppSelector(state => gradeSelectById(state, 33))!;
  const gradeExam = useAppSelector(state => gradeSelectById(state, 34))!;
  const gradeSmart = useAppSelector(state => gradeSelectById(state, 49))!;
  const gradeFinal = useAppSelector(state => gradeSelectById(state, 55))!;
  const gradeSampleExams = useAppSelector(state => gradeSelectById(state, 10071))!;

  return useMemo(
    () => ({
      gradeElementary,
      gradeFirst,
      gradeSecond,
      gradeExam,
      gradeSmart,
      gradeFinal,
      gradeSampleExams,
    }),
    [gradeElementary, gradeFirst, gradeSecond, gradeExam, gradeSmart, gradeFinal, gradeSampleExams],
  );
};
